import { render, staticRenderFns } from "./SilderCard.vue?vue&type=template&id=df92e42a&"
import script from "./SilderCard.vue?vue&type=script&lang=js&"
export * from "./SilderCard.vue?vue&type=script&lang=js&"
import style0 from "./SilderCard.vue?vue&type=style&index=0&id=df92e42a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports